import { CookieMinusOutlineIcon } from './CookieMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E5590F64-7B4E-4506-AF93-ED7F3E6AB988
 * name cookie-minus-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-minus-outline.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitMinusOutlineIcon = CookieMinusOutlineIcon;
export default BiscuitMinusOutlineIcon